import {
  Avatar,
  Box,
  Button,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import {
  APP_COLOR,
  APP_HOVER_COLOR,
  BORDER_COLOR,
  FONT_FAMILY,
  TEXT_COLOR,
} from "../../theme";

export const StyledAvatar = styled(Avatar)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "120px",
  height: "120px",
  background: "#242424",
  flex: "none",
  order: "0",
  flexGrow: "0",
  zIndex: "0",
  borderRadius: "50%",
});

export const UserDetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  fontFamily: FONT_FAMILY,
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "17px",
  [theme.breakpoints.down("sm")]: {},
  [theme.breakpoints.up("sm")]: {
    textAlign: "left",
  },
}));

export const SendMessageButton = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "150px",
  borderRadius: "8px",
  backgroundColor: APP_COLOR,
  "&:focus": { backgroundColor: APP_HOVER_COLOR },
  "&:hover": { backgroundColor: APP_HOVER_COLOR },
});

export const ButtonText = styled(Typography)({
  fontFamily: FONT_FAMILY,
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
});

export const styles = {
  userProfileContainer: {
    display: "flex",
    width: "100%",
    height: "99vh",
    overflow: "hidden",
  } as const,
  userProfileBox: {
    width: "100%",
    margin: "15px"
  } as const,
  userProfile: {
    display: "flex",
    justifyContent: "flex-end"
  } as const,
  loadingContainer: {
    width: "100%",
    height: "20vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as const,
  backButton: {
    border: `1px solid ${BORDER_COLOR}`,
    textTransform: "none",
  } as const,
  avatarAndMessageButtonContainer: {
    width: "200px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  trackContainer: {
    padding: "15px",
    borderBottom: `1px solid ${BORDER_COLOR}`,
  } as const,
  play: {
    filter: "brightness(0) invert(1)",
    color: "white",
  } as const,
  actionsContainer: {
    display: "flex",
    width: "160px",
  } as const,
  trackDetailsContainer: {
    marginLeft: "30px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%",
  } as const,
  trackLogo: {
    minWidth: "65px",
    width: "65px",
    height: "60px",
  } as const,
  readMoreButton: {
    textTransform: "none",
    color: TEXT_COLOR,
    fontSize: "16px",
    margin: 0,
    padding: 0,
  } as const,
  socialMediaBox: {
    display: "flex",
    gap: "10px",
    marginLeft: -1,
  } as const,
  trackContainerBox: {
    display: "flex",
    alignItems: "center",
    width: "250px",
  } as const,
  dialogBox: {
    display: "flex",
    justifyContent: "space-between"
  } as const,
};

export const CustomScrollingContainer = styled(Box)(({ theme }) => ({
  overflowY: "scroll",
  scrollbarWidth: "none",
  borderRadius: "0px 0px 15px 15px",
  border: `1px solid ${BORDER_COLOR}`,
  "&::-webkit-scrollbar": {
    display: "none",
  },
  maxHeight: "400px",
  [theme.breakpoints.down("md")]: {},
}));

export const TopContainer = styled(Box)(({ theme }) => ({
  height: "200px",
  marginTop: "20px",
  padding: "10px",
  display: "flex",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    height: "auto",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export const UserNameBioContainer = styled(Box)(({ theme }) => ({
  marginLeft: "15px",
  display: "flex",
  flexDirection: "column",
  paddingTop: "15px",
  width: "35%",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
}));

export const GenreAndSkillsContainer = styled(Box)(({ theme }) => ({
  width: "50%",
  borderRadius: "10px",
  border: `1px solid ${BORDER_COLOR}`,
  padding: "15px",
  height: "auto",
  marginLeft: "15px",
  [theme.breakpoints.down("lg")]: {
    width: "100%",
    marginLeft: 0,
  },
}));

export const TitlesContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  backgroundColor: "#1F242F",
  padding: "15px",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

export const TrackContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
  },
}));

export const CustomIconButtonForPlay = styled(IconButton)(({ theme }) => ({
  marginLeft: -47,
  [theme.breakpoints.down("md")]: {},
}));
